var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pb-0" }, [
        _c("h3", { staticClass: "checkout-section-title" }, [
          _vm._v(_vm._s(_vm.$t("checkout.deliveryMethods")))
        ])
      ]),
      _c(
        "v-card-text",
        [
          _vm.shippingMethods.length
            ? _c(
                "v-radio-group",
                {
                  attrs: { rules: [_vm.rules.required] },
                  model: {
                    value: _vm.form.shippingMethodId,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "shippingMethodId", $$v)
                    },
                    expression: "form.shippingMethodId"
                  }
                },
                _vm._l(_vm.shippingMethods, function(n) {
                  return _c("v-radio", {
                    key: n.id,
                    attrs: { label: n.name, value: n.id }
                  })
                }),
                1
              )
            : _vm._e(),
          !_vm.shippingMethods.length
            ? _c("div", [
                _vm._v(" " + _vm._s(_vm.$t("checkout.noDeliveryMethods")) + " ")
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }